<script setup>

    // SignInPage
    // Primary sign-in page

    // Components ----
    import SignInPageTemplate from '@/template/SignInPageTemplate';
    import SignInForm from './components/SignInForm';
    import { computed } from 'vue';
    import { store } from '@/Store';

    const isApplicationAvailable = computed(() => store.config.site?.isApplicationAvailable ?? true);
    const applicationDownMessage = computed(() => store.config.site?.applicationDownMessage
        ?? "This page was deleted or moved without a redirect.  Please check with your SXM contact for instructions on how to access the online ordering portal.");

</script>

<template>
    <SignInPageTemplate :show-footer="isApplicationAvailable">
        <div class="container page-container">

            <div class="row">
                <div class="col"></div>
                <div class="col col-12 col-sm-8 col-lg-6 col-xl-5">
                    <div v-if="isApplicationAvailable" class="sign-in-header text-center mt-5 mb-3">
                        <h1>Account Sign In</h1>
                    </div>

                    <template v-if="isApplicationAvailable">
                        <SignInForm />

                        <div class="divider mb-3">
                        </div>

                        <div class="no-account text-center">
                            <h2>Don't have an account?</h2>
                            <div class="d-grid">
                                <router-link class="btn btn-outline-color-1" to="/sign-up/account-type">CREATE ACCOUNT</router-link>
                            </div>

                        </div>
                    </template>
                    <div v-else class="application-down-message text-center" role="alert">
                        {{ applicationDownMessage }}
                    </div>
                </div>
                <div class="col"></div>
            </div>

        </div>
    </SignInPageTemplate>
</template>

<style lang="scss">

    .page-container {
        margin-bottom: 4rem;
    }

    .sign-in-header h1 {
        color: $black;
        font-weight: $normal;
    }

    .divider
    {
        height: 3rem;
        border-bottom: 1px solid $gray-20;
    }

    .no-account h2
    {
        color: $black;
        font-weight: $normal;
        font-size: 1.2rem;
    }

    .application-down-message
    {
        color: $black;
        font-size: 1.1rem;
        line-height: 1.5;
        margin: 2rem 0;
    }

    .n-text-box-field
    {
        .label
        {
            font-weight: $bold;
        }
    }

    .popper-content
    {
        width: 200px;
    }

</style>